import styled from 'styled-components';
import { theme } from '@marriott/mi-ui-library-shop';

interface ContainerProps {
  showDivider?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
  width: 100%;
`;

export const RateBlock = styled.div`
  display: flex;
  align-items: baseline;
  gap: var(--general-spacer-01, 4px);
  line-height: 1.25;
  white-space: nowrap;
  justify-content: flex-start;
`;

export const PriceText = styled.span`
  line-height: 1.25;
  color: var(--color-set-brand-fg-color, #1c1c1c) !important;
`;

export const PointsSaverPriceText = styled.span`
  line-height: 1.25;
  color: ${theme.color['verdun-green']} !important; /* verdun-green */
`;

export const CurrencyText = styled.span`
  line-height: 1.25;
`;


export const MandatoryFeeText = styled.span`
  gap: 4px;
  white-space: normal;
`;

export const InfoIconWrapper = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  margin: 0;

  /* Override AIcon size to match 12px text */
  > span {
    font-size: 12px !important;
    width: 12px;
    height: 12px;
  }

  &:hover > span {
    color: var(--color-set-brand-fg-color, #1c1c1c);
  }
`;

export const FeeModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

export const FeeModalContent = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 480px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
`;

export const FeeModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const FeeModalTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1c1c1c;
`;

export const FeeModalCloseButton = styled.button`
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #f3f4f6;
    color: #1c1c1c;
  }
`;

export const FeeModalBody = styled.div`
  margin: 0;
`;

export const FeeModalSubheading = styled.p`
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: #1c1c1c;
`;

export const FeeModalDescription = styled.ul`
  margin: 0;
  padding-left: 20px;
  font-size: 14px;
  line-height: 1.5;
  color: #4b5563;

  li {
    margin-bottom: 4px;
  }
`;

export const PointsSaverLabel = styled.span`
  display: inline-block;
  margin-bottom: 2px;
`;

export const CashPriceText = styled.span`
  white-space: normal;
  text-align: left;
`;

export const StrikeThroughPrice = styled.span`
  display: block;
  margin-bottom: 2px;
`;

export const SrOnlySeparator = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;

  &::before,
  &::after {
    content: ' ';
  }
`;
